import store from "../../store/store"

export const getSavedFilter = (moduleName: string, filterName: string) => {
    let userSettings: any = store.getState().user.UserSettings;
    if(userSettings){
        let savedFilters: any = userSettings.SavedFilters;
        if(savedFilters){
            return savedFilters[moduleName][filterName] || null;
        }
        return null;
    }
    return null;
}

export const getCategoryOfPath = (path: string) => {
    
}

